import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_3 = { class: "menu-item-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_6 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      selectData: _ctx.filterObject,
      filter: true,
      filterPlaceholder: 'message.SELECT',
      id: 'taxesRules',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTaxRules(1, true))),
      onExportFile: _ctx.exportFile
    }, null, 8, ["selectData", "filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.taxRules,
      pagination: _ctx.pagination,
      padding: 5,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader
    }, {
      "cell-name": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(_ctx.safeLocaleName(item?.name, _ctx.system_locale)), 1)
      ]),
      "cell-tax": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(_ctx.safeLocaleName(item?.tax?.name, _ctx.system_locale)), 1)
      ]),
      "cell-actions": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_2,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_3, [
              (_ctx.$can('edit_tax_rule'))
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleEdit(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_5,
                      _createTextVNode(_toDisplayString(_ctx.$t("message.EDIT")), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('delete_tax_rule'))
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleDelete(item.id)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_7,
                      _createTextVNode(_toDisplayString(_ctx.$t("message.DELETE")), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
  ]))
}